import UserRandomDto from "../../../../../../dto/UserRandomDto"

export enum ActionType {
    ALL_MOSHAVERAN_LOAGING = 'ALL_MOSHAVERAN_LOAGING',
    ALL_MOSHAVERAN_DATA = 'ALL_MOSHAVERAN_DATA',
    ALL_MOSHAVERAN_ERROR = 'ALL_MOSHAVERAN_ERROR',
    ALL_MOSHAVERAN_SHOW = 'ALL_MOSHAVERAN_SHOW'

}

export interface ActionAllMoshaveran {
    type: ActionType.ALL_MOSHAVERAN_DATA,
    data: UserRandomDto []
}

export interface ActionAllMoshaveranFetchError {
    type: ActionType.ALL_MOSHAVERAN_ERROR,
    message: String
}


type Action = ActionAllMoshaveran | ActionAllMoshaveranFetchError

export default Action